<template>

<div  class="col-12 md:col-6" >
<div class=" raised_item animate_class px-4 py-3 mb-2 flow_wrap_active">
 <h4 class=" text-primary mb-1">
  <span class="font-bold">{{$store.state.languages.lang_phrases.proje}}: </span>
  <span class="font-medium text-primary mb-1 cut-text">{{getTheTranslation(projectsupplier.project,"translation")}}</span>
</h4>

 <h4 class=" text-primary mb-1 mt-0">
  <span class="font-bold">{{$store.state.languages.lang_phrases.proje_durumu}}: </span>
 <span>
  <Tag 
class="ml-2  mt-1 mb-0 custom-chip" 
:value="projectstatus" 
:style="'background-color:'+projectstatuscolor"
/></span>
</h4>





<template v-if="loading">
<div class="flow_dashboard_wrap mb-2 pt-3 pl-2">
<Skeleton width="15rem" height="2rem" class="mb-2"></Skeleton>
<Skeleton width="5rem" height="1.6rem" class="mb-2"></Skeleton>
<Skeleton height="2rem" width="20rem" class="mb-2"></Skeleton>
</div>
</template>

<template v-else>







<SupplierDashboardFlowsupplier 
:flowsupplier="lastflowsupplier"
:projectsupplier="projectsupplier">
</SupplierDashboardFlowsupplier>







<!--
<CollapsableFlowCard viewer="supplier"  
v-for="flowsupplier in flowsuppliers"
:flowsupplier="flowsupplier" 
:activeflow="projectsupplier.activeflow">
  
</CollapsableFlowCard>
-->



</template>

</div>
</div>



</template>

<script>
import SupplierDashboardFlowsupplier from "./SupplierDashboardFlowsupplier"
export default {

  name: 'SupplierDashboardProject',
  props:["projectsupplier"],
  data () {
    return {
      loading:true,
      flowsuppliers:[],
    }
  },
  components:{SupplierDashboardFlowsupplier},
  mounted()
  {
  	this.getData()
  },
  computed:{
    lastflowsupplier()
    {
      if(this.flowsuppliers.length)
      {
        return this.flowsuppliers[this.flowsuppliers.length-1]
      }
      return null
    },
    projectstatus()
    {
      if(this.projectsupplier.status=="created")
      {
        return this.$store.state.languages.lang_phrases.olusturuldu
      }
      if(this.projectsupplier.status=="started")
      {
        return this.$store.state.languages.lang_phrases.baslandi
      }
      if(this.projectsupplier.status=="finished")
      {
        return this.$store.state.languages.lang_phrases.tamamlandi0
      }

    },
    projectstatuscolor()
    {
      if(this.projectsupplier.status=="created")
      {
        return "#352f8d"
      }
      if(this.projectsupplier.status=="started")
      {
        return "#dd4b39"
      }
      if(this.projectsupplier.status=="finished")
      {
        return "#4dc247"
      }
      
    },
  },
  methods:{
  	async getData()
  	{
  		this.loading = true
      this.flowsuppliers = await this.generalApiGet("flowsuppliers_for_dashboard/"+this.projectsupplier.id) 
      console.log(this.flowsuppliers)
      this.loading = false
      
  	},
  },
}
</script>

<style lang="css" scoped>
</style>